import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [
  // 重定向首页
  { path: '/', redirect: '/historyMsg' },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    children:[
      {
        path: '/enroll',
        name: 'enroll',
        component: () => import('../components/enroll.vue'),
        children:[
          {
            path: '/achievementIndex',
            name: 'achievementIndex',
            component: () => import('../components/achievementIndex.vue'),
          }, {
            path: '/achievementMsg',
            name: 'achievementMsg',
            component: () => import('../components/achievementMsg.vue'),
          },
        ]
      },  
      {
        path: '/sbchistoryMsg',
        name: 'sbchistoryMsg',
        component: () => import('../views/sbchistoryMsg.vue'),
        children:[
        //   {
        //     path: '/achievementIndex',
        //     name: 'achievementIndex',
        //     component: () => import('../components/achievementIndex.vue'),
        //   }, {
        //     path: '/achievementMsg',
        //     name: 'achievementMsg',
        //     component: () => import('../components/achievementMsg.vue'),
        //   },
         ]
      },
      {
        path: '/historyMsg',
        name: 'historyMsg',
        component: () => import('../views/historyMsg.vue'),
        children:[
        //   {
        //     path: '/achievementIndex',
        //     name: 'achievementIndex',
        //     component: () => import('../components/achievementIndex.vue'),
        //   }, {
        //     path: '/achievementMsg',
        //     name: 'achievementMsg',
        //     component: () => import('../components/achievementMsg.vue'),
        //   },
         ]
      }, 
      {
        path: '/enrollmentResult',
        name: 'enrollmentResult',
        component: () => import('../components/enrollmentResult.vue'),
      }, 
      {
        path: '/enrollmentResultIndex',
        name: 'enrollmentResultIndex',
        component: () => import('../components/enrollmentResultIndex.vue'),
      }, 
    ]
  },
 
]

const router = new VueRouter({
  routes
})

export default router
